(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-rfa-root]";
  var TERM_SELECTOR = "[data-rfa-content] a[href*='/pages/weinwissen/']";
  var cache = new Map();

  function requestHtml(pathname) {
    if (typeof window.fetch === "function") {
      return window.fetch(pathname, { credentials: "same-origin", headers: { Accept: "text/html" } })
        .then(function (response) {
          if (!response.ok) throw new Error("GLOSSARY_FETCH_FAILED");
          return response.text();
        });
    }
    return new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.open("GET", pathname, true);
      request.setRequestHeader("Accept", "text/html");
      request.withCredentials = true;
      request.onload = function () {
        if (request.status >= 200 && request.status < 300) resolve(request.responseText);
        else reject(new Error("GLOSSARY_FETCH_FAILED"));
      };
      request.onerror = function () { reject(new Error("GLOSSARY_FETCH_FAILED")); };
      request.send();
    });
  }

  function sameOriginTermUrl(rawHref) {
    try {
      var url = new URL(rawHref, window.location.href);
      if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}\/)?pages\/weinwissen\/[a-z0-9-]+\/?$/u.test(url.pathname)) return null;
      url.hash = "";
      return url;
    } catch (_) {
      return null;
    }
  }

  function labels() {
    var english = (document.documentElement.lang || "").toLowerCase().indexOf("en") === 0;
    return english
      ? { eyebrow: "WINE GLOSSARY", loading: "Loading…", error: "The short definition is temporarily unavailable.", more: "Read the full entry", close: "Close definition" }
      : { eyebrow: "WEINLEXIKON", loading: "Wird geladen…", error: "Die Kurzdefinition ist vorübergehend nicht verfügbar.", more: "Vollständigen Eintrag lesen", close: "Definition schließen" };
  }

  function createPopover(root) {
    var copy = labels();
    var popover = document.createElement("aside");
    popover.className = "rfa-glossary-popover";
    popover.id = "rfa-glossary-popover-" + root.dataset.articleId;
    popover.setAttribute("role", "dialog");
    popover.setAttribute("aria-modal", "false");
    popover.setAttribute("aria-live", "polite");
    popover.hidden = true;
    popover.innerHTML =
      '<button class="rfa-glossary-popover__close" type="button" aria-label="' + copy.close + '">×</button>' +
      '<span class="rfa-glossary-popover__eyebrow">' + copy.eyebrow + '</span>' +
      '<strong class="rfa-glossary-popover__title"></strong>' +
      '<p class="rfa-glossary-popover__definition"></p>' +
      '<a class="rfa-glossary-popover__more" href="#">' + copy.more + ' →</a>';
    root.appendChild(popover);
    return popover;
  }

  function positionPopover(popover, anchor) {
    if (window.matchMedia("(max-width: 740px)").matches) {
      popover.style.removeProperty("top");
      popover.style.removeProperty("left");
      return;
    }
    var rect = anchor.getBoundingClientRect();
    var width = Math.min(360, window.innerWidth - 32);
    var left = Math.min(Math.max(16, rect.left), window.innerWidth - width - 16);
    var preferredTop = rect.bottom + 12;
    var height = popover.offsetHeight || 210;
    var top = preferredTop + height <= window.innerHeight - 16 ? preferredTop : Math.max(16, rect.top - height - 12);
    popover.style.left = left + "px";
    popover.style.top = top + "px";
  }

  function initialize(root) {
    if (root.dataset.rfaGlossaryReady === "true") return;
    root.dataset.rfaGlossaryReady = "true";
    var terms = Array.prototype.slice.call(root.querySelectorAll(TERM_SELECTOR)).filter(function (term) { return sameOriginTermUrl(term.href) !== null; });
    if (!terms.length) return;

    var copy = labels();
    var popover = createPopover(root);
    var title = popover.querySelector(".rfa-glossary-popover__title");
    var definition = popover.querySelector(".rfa-glossary-popover__definition");
    var more = popover.querySelector(".rfa-glossary-popover__more");
    var close = popover.querySelector(".rfa-glossary-popover__close");
    var active = null;

    function hide() {
      if (active) active.setAttribute("aria-expanded", "false");
      active = null;
      popover.hidden = true;
    }

    function show(term) {
      var url = sameOriginTermUrl(term.href);
      if (!url) return;
      if (active && active !== term) active.setAttribute("aria-expanded", "false");
      active = term;
      term.setAttribute("aria-expanded", "true");
      title.textContent = (term.textContent || "").trim();
      definition.textContent = copy.loading;
      more.href = url.pathname;
      popover.hidden = false;
      positionPopover(popover, term);

      var key = url.pathname;
      var request = cache.get(key) || requestHtml(url.pathname)
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, "text/html");
          var pageTitle = page.querySelector(".wl__hero h1, .wl__entry h1, h1");
          var pageDefinition = page.querySelector(".wl__definition");
          if (!pageDefinition || !(pageDefinition.textContent || "").trim()) throw new Error("GLOSSARY_DEFINITION_MISSING");
          return { title: pageTitle ? (pageTitle.textContent || "").trim() : (term.textContent || "").trim(), definition: (pageDefinition.textContent || "").trim() };
        });
      cache.set(key, request);
      request.then(function (entry) {
        if (active !== term) return;
        title.textContent = entry.title;
        definition.textContent = entry.definition;
        positionPopover(popover, term);
      }).catch(function () {
        cache.delete(key);
        if (active === term) definition.textContent = copy.error;
      });
    }

    terms.forEach(function (term) {
      term.classList.add("rfa-glossary-term");
      term.setAttribute("aria-haspopup", "dialog");
      term.setAttribute("aria-expanded", "false");
      term.setAttribute("aria-controls", popover.id);
      term.addEventListener("click", function (event) {
        event.preventDefault();
        if (active === term && !popover.hidden) hide(); else show(term);
      });
    });

    close.addEventListener("click", function () { var previous = active; hide(); if (previous) previous.focus(); });
    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!popover.hidden && !popover.contains(target) && !(target && target.closest && target.closest(TERM_SELECTOR))) hide();
    });
    document.addEventListener("keydown", function (event) { if (event.key === "Escape" && !popover.hidden) hide(); });
    window.addEventListener("resize", function () { if (active && !popover.hidden) positionPopover(popover, active); }, { passive: true });
    window.addEventListener("scroll", function () { if (active && !popover.hidden) positionPopover(popover, active); }, { passive: true });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), initialize); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true }); else boot();
}());
